import React, { useEffect } from 'react';
import { analytics } from '../lib/firebase';
import { logEvent } from 'firebase/analytics';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
  useEffect(() => {
    // Log app initialization
    if (analytics) {
      try {
        logEvent(analytics, 'app_open');
        console.log('📊 Analytics: App opened event logged');
      } catch (error) {
        console.warn('📊 Analytics: Error logging app_open:', error);
      }
    } else {
      console.warn('📊 Analytics: Not initialized');
    }
  }, []);

  return <>{children}</>;
};